import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params) {
    return store.dispatch('checkResponseApi', await Api().get('goodsreceipts', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('goodsreceipt?gr_id=' + data.gr_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('goodsreceipt', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('goodsreceipt', data, options))
  },

  async done (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('goodsreceipt/done', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('goodsreceipt', { data: data }, options))
  },

  async getLatestCode (data) {
    let param = '?warehouse_id=' + data.warehouse_id +
								'&short_name=' + data.short_name
    return store.dispatch('checkResponseApi', await Api().get('goodsreceipt/latest_code' + param))
  },

}



// WEBPACK FOOTER //
// ./src/api/GoodsReceiptService.js